<template>
  <el-dialog
    :title="title"
    width="60%"
    :visible.sync="visible"
    @close="handleClose"
    :append-to-body="true"
  >
    <div class="compact-add-update" v-loading="loading">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        id="form"
        label-width="120px"
        enctype="multipart/form-data"
      >
        <el-row>
          <el-col :span="11">
            <el-form-item label="客户名称：" prop="customerId">
              <el-select
                :disabled="clickFrom === 'update'"
                clearable
                filterable
                remote
                reserve-keyword
                placeholder="请选择客户名称"
                @focus="handleSelectFocus"
                @change="handleSelectChange"
                @clear="handleSelectClear"
                :remote-method="handleCustomSearch"
                :loading="selectData.loading"
                :value="searchCustomer"
              >
                <el-option
                  v-for="item in selectList"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                  <div
                    v-if="
                      [item.name, item.depaName].filter(Boolean).join('-')
                        .length > 40
                    "
                  >
                    <el-tooltip
                      class="item custom-select-item"
                      effect="dark"
                      :content="
                        [item.name, item.depaName].filter(Boolean).join('-')
                      "
                      placement="top"
                    >
                      <span style="float: left" class="select-item-left">{{
                        [item.name, item.depaName].filter(Boolean).join('-')
                      }}</span>
                    </el-tooltip>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.customerNo }}</span
                    >
                  </div>
                  <div v-else>
                    <span style="float: left" class="select-item-left">{{
                      [item.name, item.depaName].filter(Boolean).join('-')
                    }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.customerNo }}</span
                    >
                  </div>
                </el-option>
                <el-option
                  v-if="
                    customSelectData.totalCount > selectData.pageSize &&
                      selectData.pageIndex < customSelectData.totalPages
                  "
                  label="点击加载更多"
                  value="点击加载更多"
                  :disabled="true"
                  style="cursor:pointer;"
                >
                  <span @click="handleMoreCustomList()">点击加载更多</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="关联商机：">
              <el-select
                clearable
                filterable
                remote
                reserve-keyword
                placeholder="请选择商机名称"
                @focus="handleBusiSelectFocus"
                @change="handleBusiSelectChange"
                @clear="handleBusiSelectClear"
                :remote-method="handleBusiSearch"
                :loading="selectBusiData.loading"
                :value="searchBusi"
              >
                <el-option
                  v-for="item in selectBusiList"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                >
                  <el-tooltip
                    v-if="item.name.length > 40"
                    class="item custom-select-item"
                    effect="dark"
                    :content="item.name"
                    placement="top"
                  >
                    <span>{{ item.name }}</span>
                  </el-tooltip>
                  <span v-else>{{ item.name }}</span>
                </el-option>
                <el-option
                  v-if="busiSelectData.totalPages > selectBusiData.pageIndex"
                  label="点击加载更多"
                  value="点击加载更多"
                  :disabled="true"
                  style="cursor:pointer;"
                >
                  <span @click="handleMoreBusiList()">点击加载更多</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="合同编号：" prop="contractNo">
              <el-input v-model="form.contractNo" name="contractNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="合同类型：" prop="contractType">
              <el-select clearable v-model="form.contractType">
                <el-option
                  v-for="item in compactType"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item
              label="签订日期："
              class="date-add-return"
              prop="signDate"
            >
              <el-date-picker
                :editable="false"
                value-format="yyyy-MM-dd"
                v-model="form.signDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="产品线：" prop="businessLine">
              <el-select clearable v-model="form.businessLine">
                <el-option
                  :key="item.uid"
                  v-for="item in busiLineList"
                  :label="item.name"
                  :value="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="合同金额(元)：" prop="contractAmountStr">
              <el-input
                v-model="form.contractAmountStr"
                name="contractAmountStr"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="结算方式：" prop="settlementType">
              <el-select clearable v-model="form.settlementType">
                <el-option
                  v-for="item in settlementType"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="合同开始日期：" prop="startDate">
              <el-date-picker
                :editable="false"
                value-format="yyyy-MM-dd"
                v-model="form.startDate"
                name="startDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="合同结束日期：" prop="endDate">
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="form.endDate"
                name="endDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注：" prop="remarks">
              <el-input
                type="textarea"
                placeholder="不超过500字"
                :rows="4"
                v-model="form.remarks"
                name="remarks"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="上传附件：" v-if="clickFrom !== 'update'">
            <el-upload
              ref="upload"
              class="upload-demo"
              action="action"
              :http-request="handleUpdate"
              :before-upload="beforeAvatarUpload"
              :on-success="handleOnSuccess"
              :on-error="handleOnError"
              :file-list="uploadList"
              :before-remove="beforeRemove"
            >
              <crm-button :text="'上传'"></crm-button>
            </el-upload>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <crm-button
        :buttonType="'plain'"
        :text="'取消'"
        @click="handleCancel"
      ></crm-button>
      <crm-button
        :text="'确定'"
        :disabled="isSubmitDisabled"
        @click="handleSubmit"
      ></crm-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { uploadFileVerify } from '@/scripts/reg';

export default {
  props: {
    addUpdateVisible: {
      type: Boolean,
    },
    clickFrom: {
      type: String,
    },
    detail: {
      type: Object,
    },
  },
  data() {
    const totalMoneyRule = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!/^\d+(\.\d{0,2})?$/.test(value)) {
        callback(new Error('请输入最多两位小数且无逗号的数字'));
      } else if (value > 999999999.99) {
        callback(new Error('最大999999999.99'));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      visible: false,
      title: '',
      // 限制连续保存
      isSubmitDisabled: false,
      // 客户下拉列表
      isMore: false,
      selectData: {
        loading: false,
        query: '',
        pageIndex: 1,
        pageSize: 5,
      },
      selectList: [],
      // 商机下拉列表
      selectBusiData: {
        loading: false,
        query: '',
        pageIndex: 1,
        pageSize: 5,
      },
      selectBusiList: [],
      // 打开窗口时用来搜索匹配商机的uid
      busiSelectSearchUid: '',
      // 用来搜索商机的客户id
      customSelectSearchUid: '',
      form: {
        id: '',
        customerId: '',
        businessId: '',
        contractNo: '',
        contractType: '',
        signDate: '',
        businessLine: '',
        settlementType: '',
        contractAmountStr: '',
        startDate: '',
        endDate: '',
        remarks: '',
        files: [],
      },
      uploadList: [],
      rules: {
        customerId: [
          { required: true, message: '请选择客户名称', trigger: 'change' },
        ],
        contractNo: [
          { required: true, message: '请填写合同编号', trigger: 'blur' },
          { max: 50, message: '不超过50个字', trigger: 'blur' },
        ],
        contractType: [
          { required: true, message: '请选择合同类型', trigger: 'change' },
        ],
        signDate: [
          { required: true, message: '请选择签订日期', trigger: 'change' },
        ],
        businessLine: [
          { required: true, message: '请选择产品线', trigger: 'change' },
        ],
        contractAmountStr: [{ validator: totalMoneyRule, trigger: 'blur' }],
        remarks: [{ max: 500, message: '不超过500个字', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      customSelectData: 'compact/customSelectData',
      busiLineList: 'business/busiLineList',
      compactType: 'compact/compactType',
      settlementType: 'compact/settlementType',
      busiSelectData: 'compact/busiSelectData',
    }),
    // 避免客户和商机下拉框点击更多数据时搜索关键字消失
    searchCustomer() {
      return this.form.customerId || this.selectData.query;
    },
    searchBusi() {
      return this.form.businessId || this.selectBusiData.query;
    },
  },
  watch: {
    9977(val) {
      this.visible = val;
      if (val) {
        // 窗口打开时清除客户和商机的搜索字段
        this.selectData.query = '';
        this.selectBusiData.query = '';
        // 获取detail数据时有时会赋值失败，窗口打开时重新给客户和商机下拉框赋值
        if (this.clickFrom === 'customAdd') {
          this.form.customerId = this.detail.customerId;
        }
        if (this.clickFrom === 'update') {
          this.form.customerId = this.detail.customerId;
          this.form.businessId = this.detail.businessId;
        }
        // 获取合同类型
        if (this.compactType.length === 0) {
          this.getCompactTypeList({
            pageNumber: 1,
            pageSize: 10,
            code: 'category_contract_type',
          });
        }
        // 获取产品线
        if (this.busiLineList.length === 0) {
          this.getBusiLineList({
            pageNumber: 1,
            pageSize: 10,
            code: 'category_business_line',
          });
        }
        // 获取结算方式
        if (this.settlementType.length === 0) {
          this.getSettlementTypeList({
            pageNumber: 1,
            pageSize: 10,
            code: 'category_settlement_type',
          });
        }
        // 新增时获取客户下拉框数据且关闭转圈圈
        if (this.clickFrom === 'add') {
          this.loading = false;
          this.getCustomSelectList();
        }
        // 有客户id时，同时请求客户和商机下拉框数据之后关闭转圈圈
        if (this.detail.customerId) {
          this.loading = true;
          this.busiSearchCustomId = this.detail.customerId;
          // 商机需要与客户关联而客户id请求一次要清空掉，另存id带去请求商机数据
          this.customSelectSearchUid = this.detail.customerId;
          this.busiSelectSearchUid = this.detail.businessId;
          Promise.all([
            this.getBusiSelectList(),
            this.getCustomSelectList(),
          ]).finally(() => {
            this.loading = false;
          });
        }
      }
      // 关闭窗口时清除这几个数据
      if (!val) {
        this.form.customerId = '';
        this.form.businessId = '';
        this.busiSearchCustomId = '';
        this.selectBusiList = [];
      }
    },
    clickFrom(val) {
      if (val === 'add' || val === 'customAdd') {
        this.title = '新增合同';
      } else if (val === 'update') {
        this.title = '编辑合同';
      }
    },
    detail(val) {
      this.form = {
        id: val.id,
        customerId: val.customerId,
        businessId: val.businessId,
        contractNo: val.contractNo,
        contractType: val.contractType,
        signDate: val.signDate,
        businessLine: val.businessLine,
        settlementType: val.settlementType,
        contractAmountStr: val.contractAmountStr,
        startDate: val.startDate,
        endDate: val.endDate,
        remarks: val.remarks,
        files: [],
      };
      this.busiSearchCustomId = this.detail.customerId;
      if (this.detail.customerId && this.clickFrom === 'update') {
        this.loading = true;
        this.customSelectSearchUid = this.detail.customerId;
        this.busiSelectSearchUid = this.detail.businessId;
        Promise.all([
          this.getBusiSelectList(),
          this.getCustomSelectList(),
        ]).finally(() => {
          this.loading = false;
        });
      }
    },
  },
  methods: {
    ...mapActions({
      customSelectSearch: 'compact/customSelectSearch',
      getCompactTypeList: 'compact/getCompactTypeList',
      getBusiLineList: 'business/getBusiLineList',
      getSettlementTypeList: 'compact/getSettlementTypeList',
      busiSelectSearch: 'compact/busiSelectSearch',
      saveAddCompact: 'compact/saveAddCompact',
      updateCompact: 'compact/updateCompact',
      uploadCompactFile: 'compact/uploadCompactFile',
    }),
    beforeRemove(file) {
      const delIndex = this.uploadList.findIndex(item => item.url === file.url);
      if (delIndex !== -1) {
        this.form.files.splice(delIndex, 1);
      }
      return true;
    },
    handleOnError() {},
    async sbeforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 50MB!');
        return Promise.reject();
      }
      /* eslint-disable */
      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    handleOnSuccess(response, file, fileList) {
      this.uploadList = fileList;
    },
    handleUpdate(item) {
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在上传中，请稍后...',
        duration: 0,
        showClose: false,
      });
      const params = new FormData();
      params.append('file', item.file);
      params.append('fileName', item.file.name);
      if (this.clickFrom === 'update') {
        params.append('bizUid', this.detail.id);
      }
      this.uploadCompactFile({
        params,
        config: { 'Content-Type': 'multipart/form-data', timeout: 100000 },
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: '上传成功！',
          });
          item.onSuccess();
          this.form.files.push(res.data.data);
        })
        .catch(() => {
          item.onError();
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isSubmitDisabled = true;
          if (this.clickFrom === 'add' || this.clickFrom === 'customAdd') {
            const { id, ...params } = this.form;
            this.saveAddCompact({
              ...params,
            })
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '新增合同成功',
                });
                this.$emit('closeAddUpdate', true);
                this.uploadList = [];
                this.$refs.form.resetFields();
                this.form.files = [];
              })
              .finally(() => {
                this.isSubmitDisabled = false;
              });
          } else if (this.clickFrom === 'update') {
            const { files, ...otherParams } = this.form;
            this.updateCompact({
              ...otherParams,
            })
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '修改合同成功',
                });
                this.uploadList = [];
                this.$emit('closeAddUpdate', true);
                this.$refs.form.resetFields();
              })
              .finally(() => {
                this.isSubmitDisabled = false;
              });
          }
        }
      });
    },
    handleCancel() {
      this.$emit('closeAddUpdate');
      this.$refs.form.resetFields();
      this.form.files = [];
      this.uploadList = [];
    },
    handleClose() {
      this.$emit('closeAddUpdate');
      this.$refs.form.resetFields();
      this.form.files = [];
      this.uploadList = [];
    },
    // 客户下拉框 聚焦时请求数据
    handleSelectFocus() {
      if (this.form.customerId) return;
      this.selectData.pageIndex = 1;
      this.selectData.query = '';
      this.getCustomSelectList();
    },
    // 客户下拉框 数据变更时清空商机的id，重新给用于商机搜索的客户id赋值，没有值时清除商机下拉列表
    handleSelectChange(value) {
      this.form.businessId = '';
      if (!value) {
        this.selectBusiList = [];
      }
      this.busiSearchCustomId = value;
      this.form.customerId = value;
    },
    // 客户下拉框 数据清空时时清除搜索关键字
    handleSelectClear() {
      this.selectData.query = '';
    },
    handleCustomSearch(query) {
      this.selectData.query = query;
      this.selectData.pageIndex = 1;
      this.getCustomSelectList();
    },
    getCustomSelectList() {
      return new Promise((resolve, reject) => {
        this.customSelectSearch({
          uid: this.customSelectSearchUid,
          q: this.selectData.query,
          pageSize: this.selectData.pageSize,
          pageNumber: this.selectData.pageIndex,
        })
          .then(() => {
            this.customSelectSearchUid = '';
            if (this.selectData.pageIndex === 1) {
              this.selectList = [];
            }
            this.customSelectData.results.forEach(item => {
              this.selectList.push(item);
            });
            resolve();
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    handleMoreCustomList() {
      this.isMore = true;
      this.selectData.pageIndex += 1;
      this.getCustomSelectList();
    },
    // 商机下拉框 聚焦时请求数据
    handleBusiSelectFocus() {
      // if (this.form.businessId) return;
      this.selectBusiData.pageIndex = 1;
      this.selectBusiData.query = '';
      this.getBusiSelectList();
    },
    handleBusiSelectChange(value) {
      this.form.businessId = value;
    },
    handleBusiSelectClear() {
      this.selectBusiData.query = '';
    },
    handleBusiSearch(query) {
      this.selectBusiData.query = query;
      this.selectBusiData.pageIndex = 1;
      this.getBusiSelectList();
    },
    getBusiSelectList() {
      return new Promise((resolve, reject) => {
        if (this.busiSearchCustomId) {
          this.busiSelectSearch({
            customerId: this.busiSearchCustomId,
            uid: this.busiSelectSearchUid,
            name: this.selectBusiData.query,
            pageSize: this.selectBusiData.pageSize,
            pageNumber: this.selectBusiData.pageIndex,
          })
            .then(() => {
              this.busiSelectSearchUid = '';
              if (this.selectBusiData.pageIndex === 1) {
                this.selectBusiList = [];
              }
              this.busiSelectData.results.forEach(item => {
                this.selectBusiList.push(item);
              });
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    handleMoreBusiList() {
      this.isBusiMore = true;
      this.selectBusiData.pageIndex += 1;
      this.getBusiSelectList();
    },
  },
};
</script>

<style lang="less">
.compact-add-update {
  .mr50 {
    margin-right: 50px;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>
